import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ContentContainer, PageStyles } from './SteamyMedia.styles.ts';

const SteamyMediaOptions: {
  id: NonNullable<LayoutDataType['steamy_media']>;
  title: string;
}[] = [
  {
    id: 'no',
    title: 'No',
  },
  {
    id: 'yes',
    title: 'Yes',
  },
];

export const SteamyMedia: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'SteamyMedia',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const steamyMedia = form.watch('steamy_media');

  const handleChange = () => {
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles>
      <IonContent>
        <OnboardingNavigation />
        <ContentContainer>
          <OwnAiTitle className={'title'}>
            Up for getting steamy pics and videos right to the chat? 🔞
          </OwnAiTitle>
          <OnboardingOptionsList direction={'row'}>
            {SteamyMediaOptions.map((option) => (
              <OnboardingOptionItem
                checked={steamyMedia === option.id}
                control={form.control}
                option={option}
                name="steamy_media"
                key={option.id}
                onChange={() => handleChange()}
                TEST_ID={`steamy_media-${option.id}`}
                expand={true}
              />
            ))}
          </OnboardingOptionsList>
        </ContentContainer>
      </IonContent>
    </PageStyles>
  );
};
